"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _renderUtils = _interopRequireDefault(require("@wix/photography-client-lib/dist/src/utils/renderUtils"));

var _windowWrapper = _interopRequireDefault(require("@wix/photography-client-lib/dist/src/sdk/windowWrapper"));

var _experimentsWrapper = _interopRequireDefault(require("@wix/photography-client-lib/dist/src/sdk/experimentsWrapper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var Utils =
/*#__PURE__*/
function (_RenderUtils) {
  _inheritsLoose(Utils, _RenderUtils);

  function Utils() {
    return _RenderUtils.apply(this, arguments) || this;
  }

  var _proto = Utils.prototype;

  _proto.isWixIframe = function isWixIframe() {
    return _windowWrapper["default"] && !_windowWrapper["default"].isMock && _windowWrapper["default"].Wix && !_windowWrapper["default"].Wix.isMock && _windowWrapper["default"].top !== _windowWrapper["default"].self;
  };

  _proto.scrollTo = function scrollTo(element, to, duration, isHorizontal, callback) {
    if (this.isMobile()) {
      duration = 0; //do not animate scroll on mobile (looks jumpy and buggy)
    }

    var easeInOutQuad = function easeInOutQuad(currentTime, start, change, duration) {
      //t = current time
      //b = start value
      //c = change in value
      //d = duration
      if (duration === 0) {
        return change + start;
      }

      currentTime /= duration / 2;

      if (currentTime < 1) {
        return change / 2 * currentTime * currentTime + start;
      }

      currentTime--;
      return -change / 2 * (currentTime * (currentTime - 2) - 1) + start;
    };

    var start = isHorizontal ? element.scrollLeft : element.scrollTop;
    var change = to - start;
    var currentTime = 0;
    var increment = 20;

    var animateScroll = function animateScroll() {
      currentTime += increment;
      var val = easeInOutQuad(currentTime, start, change, duration);

      if (currentTime < duration) {
        setTimeout(animateScroll, increment);
      } else {
        element.setAttribute('data-scrolling', '');

        if (typeof callback === 'function') {
          callback();
        }
      }

      if (isHorizontal) {
        element.scrollLeft = val;
      } else {
        element.scrollTop = val;
      }
    };

    element.setAttribute('data-scrolling', 'true');
    animateScroll();
  } // isVerbose() {
  //   return window.isMock || (!this.isTest() && ((this.safeLocalStorage() || {}).forceDevMode === 'true'));
  // }
  ;

  return Utils;
}(_renderUtils["default"]);

var _default = new Utils();

exports["default"] = _default;